import {ChevronRight} from '@material-ui/icons';
import {DoughnutChart} from '../../../components';
import {numberWithCommas} from '../../../Helpers/stringFormat';
export default function UntungRugiCard({
  untungRugiSemasa,
  title,
  untung,
  rugi,
  onClick,
}) {
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    responsiveAnimationDuration: 0,
    aspectRatio: 1,
    width: '100%',
    plugins: {
      tooltip: {
        enabled: false, // set this to false to hide the tooltip
      },
      legend: {
        display: false, // set this to false to hide the legend
      },
    },
  };
  return (
    <div className='ug_card' onClick={onClick}>
      <div className='ug_card_doughnut_wrapper'>
        <div className='ug_card_doughnut'>
          <DoughnutChart
            data={{
              labels: ['Rugi', 'Untung'],
              datasets: [
                {
                  label: 'Projek',
                  data:
                    rugi && untung
                      ? [rugi, untung]
                      : untungRugiSemasa > 0
                      ? [0, 1]
                      : [1, 0],
                  backgroundColor: ['#E51D28', '#2B5180'],
                  hoverBackgroundColor: ['#E51D28', '#2B5180'],
                  borderColor: ['#E51D28', '#2B5180'],
                  borderWidth: 1,
                },
              ],
            }}
            options={options}
          />
        </div>
        <p>{title}</p>
      </div>
      <div
        className={`ug_highlight_card  ${
          untungRugiSemasa > 0 ? 'untung' : 'rugi'
        }`}
      >
        <p>RM {numberWithCommas(untungRugiSemasa)}</p>
      </div>
      {/* <ChevronRight className='icon_checvron_right' height={40} /> */}
    </div>
  );
}
